const host = typeof window !== 'undefined' ? window.location.hostname : '';
const port = typeof window !== 'undefined' ? window.location.port : '';
const isLocalHost = host === 'localhost' || host === '127.0.0.1';
const instanceEnv = (import.meta.env.VITE_INSTANCE_ENV || '').toLowerCase();
const isDevFromEnv = instanceEnv === 'dev' || instanceEnv === 'development';
const isProdFromEnv = instanceEnv === 'prod' || instanceEnv === 'production';
const isDevVmIp =
  host === '10.51.75.203' &&
  (port === '8091' || port === '');
const isProdVmIp =
  host === '10.51.75.201' &&
  (port === '8091' || port === '');
const isDevHost =
  host.includes('phsims-dev') ||
  host.startsWith('dev.') ||
  host.includes('-dev.');
const isProdHost =
  host === 'web.phsims.znphi.co.zm' ||
  host.includes('.web.phsims.znphi.co.zm') ||
  isProdVmIp;

export const IS_DEV_INSTANCE =
  !isProdHost &&
  (isDevFromEnv || (!isProdFromEnv && (isLocalHost || isDevVmIp || isDevHost)));

const fallbackSiteUrl = isLocalHost
  ? 'http://localhost:8091'
  : (isDevHost ? 'https://phsims-dev.znphi.co.zm' : 'https://web.phsims.znphi.co.zm');

const fallbackDeveloperPortalUrl = isLocalHost
  ? 'http://localhost:5174'
  : 'https://developer.phsims.znphi.co.zm';

const fallbackApiDocsUrl = isLocalHost
  ? 'http://localhost:8000/docs'
  : `${typeof window !== 'undefined' ? window.location.origin : ''}/docs`;

export const SITE_URL = (import.meta.env.VITE_SITE_URL || fallbackSiteUrl).replace(/\/$/, '');
export const DEVELOPER_PORTAL_URL = (
  import.meta.env.VITE_DEVELOPER_PORTAL_URL || fallbackDeveloperPortalUrl
).replace(/\/$/, '');
export const API_DOCS_URL = (import.meta.env.VITE_API_DOCS_URL || fallbackApiDocsUrl).replace(/\/$/, '');
